function jsfill(){
    $('input[name="jsfilled"]').val('filled')
    $('.jsfill').val('filled');
}
